import moment from 'moment'

const isDateFormat = (dateStr: string | Date) => {
  return moment(dateStr, 'M/D/YYYY', true).isValid()
}

export default isDateFormat
